import { ApiClientErrorResponse } from '~/ApiClient';

export default class PasswordLoginErrorResponse extends ApiClientErrorResponse {
	handleUserNotFound(): boolean {
		return this.handle('authentication-user-not-found');
	}

	handlePasswordDoesNotMatch(): boolean {
		return this.handle('authentication-password-does-not-match');
	}

	handleInvalidEmail(): boolean {
		return this.handleWith((error) => {
			return (
				error.code === 'request-validation-error' &&
				error.source?.pointer === '/email' &&
				error.details === 'Field must be a well-formed email address'
			);
		});
	}

	handleAuthenticationAccountRegistrationNotCompleted(): boolean {
		return this.handle('authentication-account-registration-not-completed');
	}

	handleAuthenticationExpiredAccount(): boolean {
		return this.handle('authentication-expired-account');
	}

	handleAuthenticationAccountDeactivated(): boolean {
		return this.handle('authentication-account-deactivated');
	}
}
